/* eslint-disable */


/**
 * Create styles for `<OrderActions />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderActions />` styles
 */
const orderActionsStyles = ({ theme }) => ({});

export default orderActionsStyles;
